import { BrameCampaign } from 'api/brameCampaigns'
import { useHeaderContext } from 'components/Header'
import { useEffect } from 'react'
import AddGameFormHeader from './AddGameFormHeader'
import AddGameForm from './index'

interface AddGameFormContainerProps {
  onCancel: () => void
  onSave: () => void // Simplified since RTK handles the actual save
  editingGame?: BrameCampaign | null
}

const AddGameFormContainer = ({
  onCancel,
  onSave,
  editingGame,
}: AddGameFormContainerProps) => {
  const { setShouldShow: setHeaderShow } = useHeaderContext()

  // Hide the global header when this component is mounted
  useEffect(() => {
    setHeaderShow(false)
    return () => {
      setHeaderShow(true) // Re-enable header on unmount
    }
  }, [setHeaderShow])

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#f8f9fa',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AddGameFormHeader editingGame={editingGame} onCancel={onCancel} />

      <div
        style={{
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <AddGameForm onSave={onSave} editingGame={editingGame} />
      </div>
    </div>
  )
}

export default AddGameFormContainer
